/**
 * Parse a string date and return a Date object
 * @param {string} dateString
 * @returns {Date | undefined} returns a Date or undefined
 */
const parseStringToDate = (dateString: string): Date | undefined => {
  try {
    let d: number = Date.parse(dateString);
    if (isNaN(d) === false) {
      return new Date(d);
    } else {
      return undefined;
    }
  } catch (ex) {
    console.error("Unable to parse date", ex);
    return undefined;
  }
};

/**
 * Convert a Date into `yyyy-mm-ddT00:00:00` format
 * @param {Date} date date to convert to string
 * @returns {string} `yyyy-mm-ddT00:00:00`
 */
const formatDateStringLong = (date: Date): string => {
  try {
    let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(date);
    let da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    return `${ye}-${mo}-${da}T00:00:00`;
  } catch (ex) {
    console.error("Something went wrong", ex);
    return "";
  }
};

/**
 * Format a long string to simple d/mm/yyyy format
 * @param {string} longStringDate
 * @returns {string} `d/mm/yyyy`
 */
const formatDateStringShort = (longStringDate: string): string => {
  try {
    let d: number = Date.parse(longStringDate);

    let ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
    let mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(d);
    let da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(d);

    return `${da}/${mo}/${ye}`;
  } catch (ex) {
    return "";
  }
};

/** Date manipulation using INTL and Date */
const DateUtils = {
  parseStringToDate,
  formatDateStringLong,
  formatDateStringShort,
};

export default DateUtils;
